import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { LavoriApi } from "../data/apis";
import { useMemo } from "react";

export function useLavoroDataSource(personaleId: number, daData: Date, aData: Date) {    
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new LavoriApi(apiConfiguration);

        return new CustomStore({
            key: 'idLavoro',
            loadMode: 'raw',
            load: (loadOptions) => {
                return api.getLavori({
                    personaleId: personaleId,
                    daData: daData,
                    aData: aData
                })
            }
        })
      }, [personaleId, daData, aData, apiConfiguration]);
    
      return dataSource;
}
